// src/hooks/useGlobalAlarms.js
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const EMPTY_DEVICES = [];

export const useGlobalAlarms = () => {
  // Keep selector for future compatibility, but do not derive alarms from frontend state.
  const devices = useSelector((state) => state?.devices?.allDevices || state?.fleet?.devices || EMPTY_DEVICES);

  useEffect(() => {
    void devices;
  }, [devices]);
};
